<div [style.height.px]="innerHeight">
  <div class="ps" [perfectScrollbar]="sconfig">
      <div class="timeline-head text-center">Time Motion View</div>
      <div *ngIf="loading">
          <div class="loader"><div class="post-loader-svg"></div></div>
      </div> 
      <div *ngIf="!loading" class="timeline-container">
        <div
          class="timeline-row"
          *ngFor="let event of timeLineData; let i = index"
          [ngClass]="{
            'admin-left': event.isAdmin,
            'user-right': !event.isAdmin
          }"
        >
          <!-- Admin (Left Side) -->
          <div class="timeline-side left {{event.markerClassStr}}" *ngIf="event.isAdmin">
            <div class="timeline-card left-card">
              <p>
                {{ event.messageStr }} {{ event.dateStr}} by {{ event.userNameStr }}
              </p>
              <div class="device-info">
                <span class="device-label">Device:</span>
                <span class="device-data">{{event.deviceStr}}</span>
              </div>
            </div>
          </div>

          <!-- Center marker -->
          <div class="timeline-marker {{event.markerClassStr}}" [style.background-color]="event.markerBgColorStr">
            <span class="timeline-icon" [style.background-image]="'url(' + event.iconBgStr + ')'"></span>
            
          </div>

          <!-- User (Right Side) -->
          <div class="timeline-side right {{event.markerClassStr}}" *ngIf="!event.isAdmin">
            <div class="timeline-card right-card">
              <p>
                {{ event.messageStr }} {{ event.dateStr }} by {{ event.userNameStr }}
              </p>
              <div class="device-info">
                <span class="device-label">Device:</span>
                <span class="device-data">{{event.deviceStr}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>